import { useFeatureFlagEnabled } from "posthog-js/react";
import { featureFlags } from "~/config/featureFlags";
import { PlatformRole } from "~/config/types";
import { useUserContext } from "./useUserContext";

// Superadmin only, matching the API's create, rename and move (the tree itself
// is readable by every role), until document sharing gives the page a purpose
// for more roles. Gates the route and the link in the user menu alike.
export const useCanManageGovernanceUnits = (): boolean => {
  const { user } = useUserContext();
  const isEnabled = useFeatureFlagEnabled(featureFlags.governanceUnits);

  return isEnabled === true && user.role === PlatformRole.superAdmin;
};
